
import { Component, Mixins } from 'vue-property-decorator'
import TableCell from '../TableCell.vue'
import DateBase from './DateBase'

@Component({
  name: 'TableCellDate'
})
class TableCellDate extends Mixins(TableCell, DateBase) {}
export default TableCellDate
